<template>
    <div class="filings-focus w-100">
        <div class="w-100">
            <FocusChart
                chart-type="range-bullet"
                :chart-data="props.data"
                :chart-overwrite-data="overwriteData"
                :chart-sort-override="chartSortOverride"
            />
            <FocusTable
                class="mt-md"
                chart-type="range-bullet"
                :table-data="props.data"
                @filter-change="onFilterChange"
            />
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useEntityStore } from '@/stores'

import FocusChart from './shared/FocusChart.vue'
import FocusTable from './shared/FocusTable.vue'

const entityStore = useEntityStore()

const props = defineProps({
    data: {
        type: Array,
        default: () => [],
    },
})

const overwriteData = ref([])
const chartSortOverride = ref([])

const onFilterChange = (data) => {
    const top10Names = data.slice(0, 10).map((item) => item.displayName)
    chartSortOverride.value = top10Names
    overwriteData.value = data.filter((item) => top10Names.includes(item.displayName))
}
</script>

<style lang="scss" scoped>
.filings-focus {
    position: relative;
}
</style>
